import classes from "./IngredientReferenceLine.module.css";

// component for each ingredient on book contents page
const IngredientReferenceLine = (props) => {
  const ingredient = props.ingredient;
  return (
    <div className={classes.ingredient_line}>
      <div className={classes.title}>{ingredient.title}</div>
      <div className={classes.quantity}>{ingredient.volume} {ingredient.unit}</div>
    </div>
  );
};

export default IngredientReferenceLine;
